import {Component, Input, OnInit} from '@angular/core';
import {BenefitType, CompanyTaxDistribution} from "../../../../core/helpers/constants";
import {OrderDetails} from "../../../../core/models/order-details";

@Component({
  selector: 'app-benefit-details-tax-source',
  templateUrl: './benefit-details-tax-source.component.html',
  styleUrls: ['./benefit-details-tax-source.component.scss']
})
export class BenefitDetailsTaxSourceComponent implements OnInit {

  @Input() benefitDetails: OrderDetails;
  @Input() companyTaxDistribution: CompanyTaxDistribution;
  constructor() { }

  ngOnInit(): void {
  }

  get hasRegularTax(): boolean {
    return ((this.benefitDetails?.taxEmployee ?? 0) + (this.benefitDetails?.taxCompany ?? 0)) > 0;
  }

  get hasCamTax(): boolean {
    return this.companyTaxDistribution === CompanyTaxDistribution.EMPLOYEE ||
      this.companyTaxDistribution === CompanyTaxDistribution.EMPLOYEE_SALARY
      ? (this.benefitDetails?.camTax ?? 0) > 0
      : false;
  }

  protected readonly CompanyTaxDistribution = CompanyTaxDistribution;
  protected readonly BenefitType = BenefitType;
}
